/**
 * Confluence 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <ConfluenceIcon className="w-8 h-8" />
 * <ConfluenceIcon className="w-12 h-12" />
 * ```
 */
export function ConfluenceIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Confluence icon"
      role="img"
    >
      <title>Confluence</title>
      <g id="Confluence">
        <path
          id="Vector"
          d="M28.2124 21.1412C19.8354 17.0567 17.3887 16.4446 13.8593 16.4446C9.71791 16.4446 6.18721 18.1834 3.03567 23.066L2.51784 23.8641C2.09415 24.5224 2 24.7573 2 25.0383C2 25.3193 2.14123 25.5554 2.65906 25.8839L7.97737 29.2177C8.25855 29.405 8.49393 29.5 8.72931 29.5C9.01177 29.5 9.20007 29.3588 9.48253 28.9354L10.3299 27.6214C11.6467 25.6016 12.8236 24.9446 14.3301 24.9446C15.6469 24.9446 17.2004 25.3206 19.1293 26.2599L24.683 28.8892C25.2479 29.1715 25.8599 29.0303 26.141 28.3721L28.7773 22.5501C29.0598 21.8931 28.8715 21.4697 28.2124 21.1412ZM3.78889 10.8575C12.1646 14.9433 14.6125 15.5541 18.1407 15.5541C22.2834 15.5541 25.8128 13.8166 28.9656 8.93273L29.4834 8.13457C29.9058 7.47757 30 7.24274 30 6.96043C30 6.67813 29.86 6.44458 29.3409 6.11608L24.0239 2.78231C23.7414 2.59367 23.5061 2.5 23.2707 2.5C22.9882 2.5 22.7999 2.64115 22.5175 3.06461L21.6714 4.37862C20.3533 6.39711 19.1776 7.05539 17.6712 7.05539C16.3531 7.05539 14.7996 6.67941 12.8707 5.7401L7.31831 3.11081C6.7534 2.8285 6.14141 2.96965 5.85895 3.62666L3.22397 9.44986C2.94152 10.1069 3.12982 10.5278 3.78889 10.8575Z"
          fill="#1868DB"
        />
      </g>
    </svg>
  );
}
